<template>
  <div class="popup">
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-btn flat slot="activator" class="dark white--text">Create new store</v-btn>
      <v-card>
        <v-card-title primary-title>
          <h2>Create a new store</h2>
        </v-card-title>
        <v-card-text>
          <v-form class="px-3" ref="form">
            <v-text-field
              label="Store name"
              v-model="name"
              prepend-icon="folder"
              :rules="inputRules"
            ></v-text-field>
            <v-textarea
              label="Information"
              v-model="information"
              prepend-icon="edit"
              :rules="inputRules"
            ></v-textarea>

            <v-menu offset-y>
              <v-text-field
                slot="activator"
                :value="formatedDate"
                label="Due date"
                prepend-icon="date_range"
                :rules="inputRules"
              ></v-text-field>
              <v-date-picker v-model="due" :landscape="true" :reactive="true"></v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn flat class="success mx-0 mt-3" @click="submit" :loading="loading">Create store</v-btn>
            <v-btn flat class="error mx-1 mt-3" @click="dialog = false">Cancel</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  data() {
    return {
      name: "",
      information: "",
      due: null,
      inputRules: [v => v.length >= 3 || "Minimun length is 3 characters"],
      loading: false,
      dialog: false
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        console.log(this.name, this.information);
        this.dialog = false;
        this.$emit("storeAdded");
      }
    }
  },
  computed: {
    formatedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    }
  }
};
</script>